// 图片View Directive
import { Directive, ComponentInternalInstance } from 'vue';
import { showPopover } from '../../core/EasyPopup';
import CImageViewer from './CImageViewer.vue';
import { noop } from 'lodash-es';

const INSTANCE_KEY = Symbol('ImageView');

interface ImageView extends HTMLElement {
  [INSTANCE_KEY]: {
    // 记录弹出的popover
    popover?: ComponentInternalInstance;
  };
}

function closePopover(el: ImageView) {
  if (el[INSTANCE_KEY].popover) {
    const inst =
      el[INSTANCE_KEY].popover.exposed ??
      (el[INSTANCE_KEY].popover.proxy as any);
    inst?.hide();
    el[INSTANCE_KEY].popover = undefined;
  }
}

export const vImageView: Directive<ImageView, boolean | undefined> = {
  created(el) {
    el[INSTANCE_KEY] = {};
  },
  mounted(el, binding) {
    el.addEventListener('mouseenter', () => {
      if (binding.value === false) return;

      const img = el.querySelector('img');
      const naturalWidth = img?.naturalWidth;
      // 404 不出发onerror, 挺奇怪
      if (!naturalWidth || naturalWidth < 2) return;
      const src = img?.getAttribute('src');
      if (!src) return;

      const placeholder = el.querySelector('.el-image__placeholder');
      // 未加载完成
      if (placeholder) return;

      const error = el.querySelector('.el-image__error');
      // 加载失败
      if (error) return;

      closePopover(el);

      showPopover(CImageViewer, { src }, el, {
        placement: 'right',
        width: 'max-content',
        defaultFooter: false,
        focus: false,
        hook: (component: any) => {
          el[INSTANCE_KEY].popover = component;
        },
        popperStyle: {
          maxWidth: '400px',
          textAlign: 'center',
          minWidth: '1px'
        }
      }).catch(noop);
    });

    el.addEventListener('mouseleave', () => {
      closePopover(el);
    });
  },

  unmounted(el) {
    closePopover(el);
  }
};
